import * as actionType from "./constants";

const initialState = {
    getSoftCosts: {},
    saveSoftCosts: {},
    excelData: {},
    saveDynamicSoftCostField: null,
    updateDynamicSoftCostField: null,
    deleteDynamicSoftCostField: null
};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_SOFT_COSTS_REQUEST:
            return {
                ...state,
                getSoftCosts: { loading: true }
            };
        case actionType.GET_SOFT_COSTS_SUCCESS:
            return {
                ...state,
                getSoftCosts: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_SOFT_COSTS_FAILURE:
            return {
                ...state,
                getSoftCosts: { loading: false, success: false, ...action.error }
            };
        case actionType.SAVE_SOFT_COSTS_REQUEST:
            return {
                ...state
            };
        case actionType.SAVE_SOFT_COSTS_SUCCESS:
            return {
                ...state,
                saveSoftCosts: { success: true, ...action.response }
            };
        case actionType.SAVE_SOFT_COSTS_FAILURE:
            return {
                ...state,
                saveSoftCosts: { success: false, ...action.error }
            };
        case actionType.SAVE_DYNAMIC_SOFT_COST_FIELD_REQUEST:
            return {
                ...state
            };
        case actionType.SAVE_DYNAMIC_SOFT_COST_FIELD_SUCCESS:
            return {
                ...state,
                saveDynamicSoftCostField: { success: true, ...action.response, data: action.data }
            };
        case actionType.SAVE_DYNAMIC_SOFT_COST_FIELD_FAILURE:
            return {
                ...state,
                saveDynamicSoftCostField: { success: false, ...action.error }
            };
        case actionType.UPDATE_DYNAMIC_SOFT_COST_FIELD_REQUEST:
            return {
                ...state
            };
        case actionType.UPDATE_DYNAMIC_SOFT_COST_FIELD_SUCCESS:
            return {
                ...state,
                updateDynamicSoftCostField: { success: true, ...action.response, data: action.data }
            };
        case actionType.UPDATE_DYNAMIC_SOFT_COST_FIELD_FAILURE:
            return {
                ...state,
                updateDynamicSoftCostField: { success: false, ...action.error }
            };
        case actionType.DELETE_DYNAMIC_SOFT_COST_FIELD_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_DYNAMIC_SOFT_COST_FIELD_SUCCESS:
            return {
                ...state,
                deleteDynamicSoftCostField: { success: true, ...action.response, data: action.data }
            };
        case actionType.DELETE_DYNAMIC_SOFT_COST_FIELD_FAILURE:
            return {
                ...state,
                deleteDynamicSoftCostField: { success: false, ...action.error }
            };
        case actionType.EXPORT_EXCEL_REQUEST:
            return {
                ...state
            };
        case actionType.EXPORT_EXCEL_SUCCESS:
            return {
                ...state,
                excelData: { success: true, ...action.response }
            };
        case actionType.EXPORT_EXCEL_FAILURE:
            return {
                ...state,
                excelData: { success: false, ...action.error }
            };
        default:
            return state;
    }
};

export default reducers;
